var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { bindable } from "aurelia-templating";
import { Guid } from "../../../utilities/guid";
import { autoinject, transient } from "aurelia-dependency-injection";
import { QueriesClientService } from "../../../services/queries/queries-client.services";
import { GridUtils } from "../data-grid/data-grid";
import { QueryFilter, DataType } from "../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { BindingSignaler } from "aurelia-templating-resources";
import { BindingEngine } from "aurelia-binding";
import { ArrayUtils } from "../../../utilities/arrays";
import { CloneUtility } from "../../../utilities/clone";
import { I18N } from 'aurelia-i18n';
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder(queriesService, bindingEngine, element, bindingSignaler, i18N) {
        this.queriesService = queriesService;
        this.bindingEngine = bindingEngine;
        this.element = element;
        this.bindingSignaler = bindingSignaler;
        this.i18N = i18N;
        this.funcsQueue = [];
        this.colors = ["#37ade7", "#ff6c4f", "#fec310", "#df5282", "#447092", "#955075", "#7482ed"];
        this.count = 0;
        this.metaDataLoaded = false;
        this.isPropertySelected = [];
        this.andOr = [
            { name: "And", isAnd: true },
            { name: "Or", isAnd: false }
        ];
        this.propValue = "";
        this.propName = "name";
        this.sortAlphabetically = true;
        this.withDynamicProperties = false;
        this.data = null;
        this.readonly = false;
        this.addNewClauseLabel = this.i18N.tr('add-new-clause-text');
        this.clauses = [];
        this.propertiesToHide = [];
    }
    QueryBuilder.prototype.validate = function () {
        var _this = this;
        this.clauses.forEach(function (x, index) {
            _this.ensureIsPropertySelectedObjectIsValid();
            _this.isPropertySelected[index].isSelected = x.filterProperty != null;
        });
        return !this.isPropertySelected.some(function (x) { return !x.isSelected; });
    };
    QueryBuilder.prototype.readonlyChanged = function () {
        this.bindingSignaler.signal("update-filters-html");
    };
    QueryBuilder.prototype.propNameChanged = function (newValue) {
        this.bind();
    };
    QueryBuilder.prototype.propValueChanged = function (newValue) {
        this.bind();
    };
    QueryBuilder.prototype.bind = function () {
        var _this = this;
        this.clausesChanged();
        this.count++;
        var count = this.count;
        this.promises =
            [
                this.queriesService.getQueryOperators(),
                this.withDynamicProperties
                    ? this.queriesService.getEntityModelWithDynamicProperties(this.propValue)
                    : this.queriesService.getEntityModels()
            ];
        Promise.all(this.promises).then(function (results) {
            if (count === _this.count && _this.propValue) {
                _this.operators = results[0];
                _this.models = results[1];
                var selectedModel = Enumerable.from(_this.models).firstOrDefault(function (x) { return x[_this.propName] && x[_this.propName].toString().toLowerCase() === _this.propValue.replace(/-/g, "").toString().toLowerCase(); });
                var propertiesToHide_1 = _this.propertiesToHide ? _this.propertiesToHide : [];
                var filterProperties_1 = [];
                selectedModel = selectedModel ? CloneUtility.cloneObject(selectedModel) : selectedModel;
                selectedModel.filterProperties.forEach(function (x) {
                    filterProperties_1.push(CloneUtility.clone(x));
                });
                selectedModel.filterProperties = filterProperties_1.filter(function (x) { return propertiesToHide_1.every(function (y) { return y !== x.name; }); });
                _this.selectedModel = selectedModel;
                if (_this.sortAlphabetically) {
                    _this.sortPropertiesOfSelectedModel();
                }
                setTimeout(function () {
                    _this.promises = null;
                    _this.funcsQueue.forEach(function (x) {
                        x();
                    });
                    _this.funcsQueue = [];
                    _this.dispatchEvent("selected-model-changed", _this.selectedModel);
                    _this.metaDataLoaded = true;
                });
            }
        });
    };
    QueryBuilder.prototype.isReady = function () {
        return this.promises == null;
    };
    QueryBuilder.prototype.resetCount = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isReady()) {
                _this.count = 0;
            }
            else {
                reject();
            }
        });
    };
    QueryBuilder.prototype.clausesChanged = function () {
        var _this = this;
        if (this.subscriptionForClausesCollectionChanges) {
            this.subscriptionForClausesCollectionChanges.dispose();
            this.subscriptionForClausesCollectionChanges = null;
        }
        this.isPropertySelected = [];
        if (this.clauses) {
            if (this.clauses && this.selectedModel) {
                this.clauses.forEach(function (x) {
                    x.isAnd = x.isAnd == null ? true : x.isAnd;
                });
            }
            this.subscriptionForClausesCollectionChanges = this.bindingEngine.collectionObserver(this.clauses).subscribe(function (changedValues) {
                if (changedValues && changedValues[0]) {
                    var countNew = changedValues[0].addedCount;
                    var startIndex = changedValues[0].index;
                    var removed = changedValues[0].removed;
                    removed.forEach(function (x) {
                        var index = ArrayUtils.findIndex(_this.isPropertySelected, function (y) { return y == x; });
                        _this.isPropertySelected.splice(index, 1);
                    });
                    var addedValues = _this.clauses.slice(startIndex, startIndex + countNew);
                    addedValues.forEach(function (x) {
                        _this.isPropertySelected.push({ property: x.filterProperty, isSelected: true });
                    });
                }
            });
        }
    };
    QueryBuilder.prototype.addFilter = function (index) {
        var _this = this;
        if (!this.promises) {
            var newFilter = new QueryFilter();
            newFilter.isAnd = true;
            if (!isNaN(index) && this.clauses.length > index) {
                this.clauses.splice(index + 1, 0, newFilter);
            }
            else {
                this.clauses.push(newFilter);
            }
        }
        else {
            this.funcsQueue.push(function () { return _this.addFilter(index); });
        }
    };
    QueryBuilder.prototype.onPropertySelected = function ($event, $index, filter) {
        var _this = this;
        this.ensureIsPropertySelectedObjectIsValid();
        this.isPropertySelected[$index].isSelected = true;
        filter.filterValue = undefined;
        setTimeout(function () {
            _this.bindingSignaler.signal("update-filters-html");
        });
    };
    QueryBuilder.prototype.removeFilter = function (item) {
        var index = this.clauses.indexOf(item);
        if (this.clauses[index].subscription && this.clauses[index].subscription.dispose) {
            this.clauses[index].subscription.dispose();
        }
        this.clauses.splice(index, 1);
        this.isPropertySelected[index].isSelected = true;
    };
    Object.defineProperty(QueryBuilder.prototype, "shouldShowGroupingAction", {
        get: function () {
            var e_1, _a;
            var count = 0;
            if (this.clauses) {
                try {
                    for (var _b = __values(this.clauses), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        if (item.selectedForGrouping) {
                            if (item.groupGuid) {
                                return false;
                            }
                            count++;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (count > 1) {
                return this.canGroup();
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryBuilder.prototype, "shouldShowUnGroupingAction", {
        get: function () {
            var e_2, _a;
            var count = 0;
            var guid = null;
            if (this.clauses) {
                try {
                    for (var _b = __values(this.clauses), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        if (item.selectedForGrouping) {
                            count++;
                        }
                        if (item.selectedForGrouping && item.groupGuid) {
                            guid = item.groupGuid;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (count >= 1) {
                if (count === 1 && Enumerable.from(this.clauses).count(function (x) { return x.groupGuid === guid; }) === 2) {
                    return false;
                }
                return !this.canGroup();
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    QueryBuilder.prototype.canGroup = function () {
        var e_3, _a;
        var inGroup = [];
        var notInGroup = [];
        if (this.clauses) {
            try {
                for (var _b = __values(this.clauses), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.selectedForGrouping) {
                        if (item.groupGuid && item.groupGuid !== "") {
                            inGroup.push(item);
                        }
                        else {
                            notInGroup.push(item);
                        }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return notInGroup.length !== 0;
    };
    QueryBuilder.prototype.groupFilters = function () {
        var e_4, _a;
        var groupColor = this.pickColorClass();
        var groupGuid = Guid.generateGuid();
        try {
            for (var _b = __values(this.clauses), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.selectedForGrouping) {
                    item.groupColor = groupColor;
                    item.groupGuid = groupGuid;
                    item.selectedForGrouping = false;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        this.reorderList();
    };
    QueryBuilder.prototype.reComputeIsLast = function () {
        var e_5, _a;
        // if the collection only has 1 left make it as is first
        var counter = 0;
        try {
            for (var _b = __values(this.clauses), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.isLast = false;
                if (counter === this.clauses.length - 1) {
                    item.isLast = true;
                }
                counter++;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    QueryBuilder.prototype.onGroupFilterClick = function () {
        var e_6, _a, e_7, _b;
        var inGroup = [];
        var notInGroup = [];
        try {
            for (var _c = __values(this.clauses), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                if (item.selectedForGrouping) {
                    if (item.groupGuid && item.groupGuid !== "") {
                        inGroup.push(item);
                    }
                    else {
                        notInGroup.push(item);
                    }
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
        if (notInGroup.length === 0) {
            try {
                for (var inGroup_1 = __values(inGroup), inGroup_1_1 = inGroup_1.next(); !inGroup_1_1.done; inGroup_1_1 = inGroup_1.next()) {
                    var item = inGroup_1_1.value;
                    item.groupColor = null;
                    item.groupGuid = null;
                    item.selectedForGrouping = false;
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (inGroup_1_1 && !inGroup_1_1.done && (_b = inGroup_1.return)) _b.call(inGroup_1);
                }
                finally { if (e_7) throw e_7.error; }
            }
            this.reorderList();
        }
        else {
            this.groupFilters();
        }
    };
    QueryBuilder.prototype.stopPropagatiopn = function ($event) {
        $event.stopPropagation();
    };
    QueryBuilder.prototype.filtersHtml = function (filter) {
        if (filter && filter.filterProperty && filter.filterProperty.type == DataType.Boolean && filter.filterValue !== false && filter.filterValue !== true) {
            filter.filterValue = false;
        }
        filter.skipOnNullOrEmpty = !filter.filterProperty.isNullable;
        var projectedProperty = this.selectedModel && this.selectedModel.projectionProperties
            ? this.selectedModel.projectionProperties.filter(function (x) { return x.name == filter.filterProperty.name; })[0]
            : null;
        var binding = {
            query: "filter.filterProperty.lookupMappedToProperty",
            isEditable: !this.readonly,
            binding: "filter.filterValue | initFilter:filter.filterProperty.type",
            value: "filter.filterProperty.lookupMappedToProperty",
            dataType: filter.filterProperty.lookupMappedToProperty && filter.filterProperty.type != DataType.HeiricalLookup ? DataType.Lookup : filter.filterProperty.type,
            parameter: "filter.filterValue",
            secondParameter: this.getSecondParameter(filter, projectedProperty),
            isNotRangeDatePicker: true,
            isSecondParameterBindable: false,
        };
        return GridUtils.getControl(binding, true);
    };
    QueryBuilder.prototype.getSecondParameter = function (filter, projectedProperty) {
        if (!projectedProperty) {
            return "";
        }
        var type = filter.filterProperty.type;
        return type == DataType.Date || type == DataType.DateTime ? projectedProperty.format : "";
    };
    QueryBuilder.prototype.getRandomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    QueryBuilder.prototype.reorderList = function () {
        var e_8, _a, e_9, _b;
        var newGroupedFilters = [];
        var groupedFilters = Enumerable.from(this.clauses)
            .groupBy(function (filter) { return filter.groupGuid; }, function (filter) { return filter; }).toArray();
        try {
            for (var groupedFilters_1 = __values(groupedFilters), groupedFilters_1_1 = groupedFilters_1.next(); !groupedFilters_1_1.done; groupedFilters_1_1 = groupedFilters_1.next()) {
                var group = groupedFilters_1_1.value;
                try {
                    for (var _c = (e_9 = void 0, __values(group.groupSource())), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        newGroupedFilters.push(item);
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (groupedFilters_1_1 && !groupedFilters_1_1.done && (_a = groupedFilters_1.return)) _a.call(groupedFilters_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
        this.clauses = newGroupedFilters;
        this.reComputeIsLast();
    };
    QueryBuilder.prototype.pickColorClass = function () {
        var selectedColor = this.colors[this.getRandomInt(0, this.colors.length - 1)];
        return selectedColor;
    };
    QueryBuilder.prototype.sortPropertiesOfSelectedModel = function () {
        for (var i = 0; i < this.selectedModel.filterProperties.length; i++) {
            var min = i;
            for (var j = i; j < this.selectedModel.filterProperties.length; j++) {
                if (this.selectedModel.filterProperties[j].friendlyName <
                    this.selectedModel.filterProperties[min].friendlyName) {
                    min = j;
                }
            }
            if (min !== i) {
                var t = this.selectedModel.filterProperties[min];
                this.selectedModel.filterProperties[min] = this.selectedModel.filterProperties[i];
                this.selectedModel.filterProperties[i] = t;
            }
        }
    };
    QueryBuilder.prototype.dispatchEvent = function (nameEvent, data) {
        if (this.element && nameEvent) {
            var customEvent = new CustomEvent(nameEvent, { bubbles: true, detail: data });
            this.element.dispatchEvent(customEvent);
        }
    };
    QueryBuilder.prototype.ensureIsPropertySelectedObjectIsValid = function () {
        if (!this.isPropertySelected) {
            this.isPropertySelected = [];
        }
        if (this.isPropertySelected.length < this.clauses.length) {
            var clausesCount = this.clauses.length;
            var diff = this.clauses.length - this.isPropertySelected.length;
            for (var index = 0; index < diff; index++) {
                this.isPropertySelected.push({ property: this.clauses[clausesCount - diff + index].filterProperty, isSelected: true });
            }
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueryBuilder.prototype, "propValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueryBuilder.prototype, "propName", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueryBuilder.prototype, "sortAlphabetically", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueryBuilder.prototype, "withDynamicProperties", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], QueryBuilder.prototype, "data", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueryBuilder.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueryBuilder.prototype, "addNewClauseLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], QueryBuilder.prototype, "clauses", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], QueryBuilder.prototype, "propertiesToHide", void 0);
    QueryBuilder = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [QueriesClientService,
            BindingEngine,
            Element,
            BindingSignaler,
            I18N])
    ], QueryBuilder);
    return QueryBuilder;
}());
export { QueryBuilder };
